import XLSX from 'xlsx'
var moment = require('moment')
moment.locale('it')
export class excelWs {

  constructor (args) {
		this.ws = {}
		this.maxCol = 0
		this.maxRow = 0
      this.range = {s: {c:0, r:0}, e: {c:0, r:0 }}
      
      this.labelFormat = {
         id:'numbersimple',
         cellulare:'string',
         telefono:'string',
         fax:'string',
         cap:'string',
         datanascita:'itadate',
         eseguitoil:'itadate',
         incassatoil:'itadate',
         inseritoil:'itadate',
         dimessoil:'itadate',
         approvatoil:'itadate'         
      }
      this.cellFormat = {
         numbersimple: {t:"n",z:"0"},
         string: {t:"s"},
         date:{t:"d",z: "yyyy-mm-dd"},
         itadate:{t:"d",z: "dd/mm/yyyy"}
      }
		console.log(":............EXCEL WS................:")
   }
   
   objmerge(){
      var objReturn = {}
      var prop
      if(arguments.length>0) for (prop in arguments[0]) objReturn[prop] = arguments[0][prop]
      if(arguments.length>1) for (prop in arguments[1]) objReturn[prop] = arguments[1][prop]
      if(arguments.length>2) for (prop in arguments[2]) objReturn[prop] = arguments[2][prop]
      if(arguments.length>3) for (prop in arguments[3]) objReturn[prop] = arguments[3][prop]
      return objReturn
   }

   data(data){
      var row = 0
      var col = 0
      var opts = {campi:[],labels:{},initCol:0,initRow:0}


      console.log("LABELS " + typeof(data) + " LENGTH " + data.length)
      if(typeof(data) !== 'object' || data.length==0)
         return this
      
      if(arguments.length>1)
         opts = this.objmerge(opts,arguments[1]) 

      /* se non vengono passati i campi dell'oggetto, li recupero dall'oggetto stesso */
      if(opts.campi.length==0)
         opts.campi = Object.keys(data[0])
   

      //if(typeof(opts.labels[colname]) == 'undefined' )   

      col = opts.initCol
      for (let campo of opts.campi){
         //console.log(typeof(opts.labels[campo]) == 'undefined' ? campo : opts.labels[campo])
         
         this.cell(opts.initRow,col,(typeof(opts.labels[campo]) == 'undefined' ? campo : opts.labels[campo]),'string')//)
         
         col++
      }

      row = opts.initRow
      for (let rows of data){
			row++
			col=opts.initCol
			for (let campo of opts.campi){
            //console.log("COLONNA: "+campo+ " TYPE OF "+ typeof(this.labelFormat[campo]) )
            if(typeof(this.labelFormat[campo]) !== 'undefined'){
               if(this.labelFormat[campo]=='date' || this.labelFormat[campo]=='itadate'){

                  this.cell(row,col,moment(rows[campo]). add(1, 'hours'),this.labelFormat[campo])
               }else{
                  this.cell(row,col,rows[campo],this.labelFormat[campo])
               }
            }
            else this.cell(row,col,rows[campo])
				col++
			}	
		}

      return this

   }
   /* scrive nel foglio un array di dati:
      labels: array contenente le intestazioni di colonna 
      data: array contenente i valori che andremo a stampare
      arg3: se presente indica il numero di riga da cui partire
      arg4: se presente indica il numero di colonna da cui partire
   */
	datafree(labels,data){
	   var cols = []
      var initialCol = 0
      var row = 0
		var col = 0

		if(arguments.length>2)
			row = arguments[2]
		if(arguments.length>3)
			initialCol = arguments[3]

		col = initialCol	
      	for (let label of labels){
          this.cell(row,col,label)
          col++
      	}
	  
		for (let rows of data){
			row++
			col=initialCol
			for (let colname of labels){
            console.log("COLONNA: "+colname+ " TYPE OF "+ typeof(this.labelFormat[colname]) )
            if(typeof(this.labelFormat[colname]) !== 'undefined'){
               this.cell(row,col,rows[colname],this.labelFormat[colname])
            }
            else this.cell(row,col,rows[colname])
				col++
			}
			
		}
		return this

	}
	cell(row,col,value){
		var cell = { v: value}
		if(this.range.e.c < col) this.range.e.c = col
      if(this.range.e.r < row) this.range.e.r = row
      
		/* create the correct cell reference */
		var cell_ref = XLSX.utils.encode_cell({c:col,r:row});

      if(arguments.length>3){
         /* Esiste una formattazione specifica */
         if(arguments[3]=='itadate' && value=='0000-00-00'){
            cell.v = ''
         }else{
            cell = this.objmerge(cell,this.cellFormat[arguments[3]]) 
            console.log(cell)
         }
      }
      else{
         /* determine the cell type */
         if(typeof cell.v === 'number') {
            cell.t = 'n'
            cell.z = "0"
         }
         else if(typeof cell.v === 'boolean') cell.t = 'b';
         else cell.t = 's';
      }
		

		/* add to structure */
		this.ws[cell_ref] = cell;
		//console.log(this.ws)
		return this
	}


}